// import React from "react"
// import {  } from "react";
import { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import API from '../utils/apiCalling';
import Loader from '../utils/loader';
import "react-data-table-component-extensions/dist/index.css";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import { toast, ToastContainer } from 'react-toastify';


const DownloadExitSurveyReport = () => {

    const api = new API
    const url = useLocation()
    const [loader, setLoader] = useState(false)
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

 const downloadResponseExcel = async () => {
    console.log(startDate, endDate,"ewrewrewewrwerwer")
    if (!startDate || !endDate) {
        toast.warning("Please select both start and end dates");
        return;
    }

    setLoader(true);

    try {
        const payload = {
            startDate,
            endDate
        };

        const response = await fetch("https://api.doyoursurvey.com:3009/Avanti/downloadExitSurveyReport", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });
        console.log(response,"response")

        if (!response.ok) {
            toast.error("No data found or download failed");
            setLoader(false);
            return;
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "ExitSurveyReport.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        setLoader(false);
    } catch (err) {
        console.error(err);
        toast.error("Error while downloading report");
        setLoader(false);
    }
};



    return (
        <main className='bg-lgrey position-relative container-fluid p-0'>
            {loader && <Loader />}
            <div>
                <div className="row mt-2">
                    <div className="col-md-3">
                        <label className='mb-2 d-block'>Start Date</label>

                        <input
                            className='form-control'
                            type='date'
                            onChange={(e) => setStartDate(e.target.value)}
                            placeholder='Start Date...'
                        />
                    </div>

                    <div className="col-md-3">
                        <label className='mb-2 d-block'>End Date</label>

                        <input
                            className='form-control'
                            type='date'
                            onChange={(e) => setEndDate(e.target.value)}
                            placeholder='End Date...'
                        />
                    </div>
                    <div className='col-md-3 mt-2'>
                        <button className='btn btn-success m-4 w-100' onClick={downloadResponseExcel}>
                            Download Exit Survey Report
                        </button>
                    </div>
                    {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <span>
                            <span className="badge text-dark fs-4 me-2" style={{ fontFamily: "monospace" }}>
                                <i className="fa fa-hashtag me-2" />
                                Total Count: -
                            </span>
                            <span className="fs-3 fw-bold text-primary">{data1.length}</span
                        </span>
                    </div> */}
                </div>
               


                <div className='w-100  powered-btn'>
                    <a href='https://qdegrees.com/' target="_blank"> <div className='mainbtnblue m-2 position-fixed bottom-0 end-0'><small className='f-12'>Powered by</small>&nbsp;<b className='f-14'>DoYourSurvey</b></div></a>
                </div>
            </div>
            <ToastContainer />
        </main >
    )

}

export default DownloadExitSurveyReport